import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { IBox, IField } from '../../document-type-settings.dto';
import { DocumentTypeFacade } from '../../../store/document-type.facade';
import { delay, of, Subscription, take } from 'rxjs';
import { IMetadataItemDto } from 'app/main/pages/settings/documentfields/metadata-item.dto';

@Component({
  selector: 'app-custom-box',
  templateUrl: './custom-box.component.html',
  styleUrl: './custom-box.component.scss'
})
export class CustomBoxComponent implements OnDestroy {

  @ViewChild('customBoxInput', { static: false }) customBoxInput;
  @Output() removeCustomBox: EventEmitter<number> = new EventEmitter<number>();
  @Output() addFieldsInCustomBox: EventEmitter<{ boxIndex: number, field: IMetadataItemDto }> = new EventEmitter<{ boxIndex: number, field: IMetadataItemDto }>();
  @Output() removeFieldFromCustomBox: EventEmitter<IMetadataItemDto> = new EventEmitter<IMetadataItemDto>();
  @Output() renameBox: EventEmitter<{ boxIndex: number, name: string }> = new EventEmitter<{ boxIndex: number, name: string }>();
  @Input() box: IBox;
  @Input() boxIndex: number;
  @Input() metaDataItems: IMetadataItemDto[] = [];

  public isEditMode: boolean = false;
  // public metaDataItems$ = this._documentTypeFacade.selectMetaDataFields$;
  protected timeOutSubcription: Subscription;

  constructor(private _documentTypeFacade: DocumentTypeFacade) { }





  /**
   * Enables edit mode for the custom box name and sets focus to the input element.
   *
   * This method sets the `isEditMode` flag to `true`, then uses an observable with a short delay
   * to ensure the input element is available in the DOM before focusing it. The subscription is
   * stored in `timeOutSubcription` for potential cleanup.
   */
  editCustomBoxName(): void {
    this.isEditMode = true;
    this.timeOutSubcription = of(null)
      .pipe(
        take(1),
        delay(1)
      ).subscribe(() => {
        this.customBoxInput.nativeElement.focus();
      })
  }




  /**
   * Handles the renaming of the custom box when the input value changes.
   * 
   * Updates the `name` property of the `box` object with the new value from the input event,
   * and exits edit mode by setting `isEditMode` to false.
   *
   * @param event - The input event triggered when the user changes the box name.
   */
  renameCustomBox(event: Event): void {
    const newName = (event.target as HTMLInputElement).value.trim();
    this.box = { ...this.box, name: newName };
    this.renameBox.emit({ boxIndex: this.boxIndex, name: newName });
    this.isEditMode = false;
  }



  /**
   * Handles the addition of a new field to the current box.
   * If the `fields` array exists and contains elements, the new field's ID is appended.
   * Otherwise, initializes the `fields` array with the new field's ID.
   *
   * @param $event - The event object containing the `id` of the field to add.
   */
  onAddingField($event: IMetadataItemDto): void {
    const selectedField = this.metaDataItems.find(item => item.id === $event.id);
    if (selectedField) {
      this.addFieldsInCustomBox.emit({ boxIndex: this.boxIndex, field: selectedField });
    }
  }




  removeField($event: IMetadataItemDto): void {
    this.removeFieldFromCustomBox.emit($event);
  }




  ngOnDestroy() {
    if (this.timeOutSubcription) {
      this.timeOutSubcription.unsubscribe();
    }
  }
}
